<template>
  <div class="userAgreeOn">
    <Navbar title="用户注册协议" :default-bg="false"/>
    <div class="text" v-html="$xss(text)"></div>
  </div>
</template>

<script>
import Navbar from "../components/NavBar";

export default {
  name: "userAgreeOn",
  components: {Navbar},
  data() {
    return {
      text: ""
    }
  },
  created() {
    this.getUserAgreeOn();
  },
  methods: {
    //获取用户协议
    getUserAgreeOn() {
      this.$post('article/register').then(result => {
        this.text = result.data;
      });
    },
  }
}
</script>

<style scoped lang="less">
.userAgreeOn {
  .text {
    padding: 0 15px;
    box-sizing: border-box;

    p {
      padding: 0;
      margin: 0;
    }
  }
}
</style>